"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultGTMTab = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const constants_1 = require("../../constants");
const useSearchResultGTMTab = (lastUserAction, gtmPageName) => {
    const { results, status } = (0, react_instantsearch_1.useInstantSearch)();
    React.useEffect(() => {
        if (lastUserAction.name !== app_1.LastUserActionNameEnum.Tab ||
            status !== 'idle' ||
            !(results === null || results === void 0 ? void 0 : results.nbHits) ||
            !(results === null || results === void 0 ? void 0 : results.exhaustive)) {
            return;
        }
        app_1.GTM.filter({
            numberOfResults: results.nbHits,
            pageName: gtmPageName,
            filterCategory: constants_1.GTM_TAB_FILTER_CATEGORY,
            filterOptions: (lastUserAction === null || lastUserAction === void 0 ? void 0 : lastUserAction.value) || '',
        });
    }, [lastUserAction, results, status]);
};
exports.useSearchResultGTMTab = useSearchResultGTMTab;
